import React from 'react';
import useResizeAware from 'react-resize-aware';

const ResizeAware = ({
  children,
  onResize,
  wrapperStyles,
}) => {
  const [resizeListener, sizes] = useResizeAware();

  React.useEffect(() => {
    if (onResize) {
      onResize(sizes);
    }
  }, [sizes.width, sizes.height]);

  return (
    <div style={wrapperStyles}>
      {resizeListener}
      {children}
    </div>
  );
};

export { ResizeAware };
